import React from 'react';
import './Solution.css';
import KeyFeatures from './KeyFeatures';
import HowItWorks from './HowItWorks';

const Solution: React.FC = () => {
  return (
    <div className="solution-page">
      {/* Hero Section */}
      <section className="solution-hero-section">
        <div className="hero-background">
          <div className="hero-gradient-overlay"></div>
          <div className="hero-particles"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge-container">
              <div className="hero-badge">
                <span className="badge-icon">🚀</span>
                <span>TRANSFORMATIVE TECHNOLOGY</span>
              </div>
            </div>
            <h1 className="hero-title">
              <span className="title-highlight">Graph Intelligence</span>
              <br />
              Platform for the Future
            </h1>
            <p className="hero-subtitle">
              Experience how our network analysis technology reveals hidden relationship patterns, 
              enabling cutting edge risk assessment and strategic decision-making across your entire operation.
            </p>
            
            {/* Hero Stats */}
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">INSTANT</div>
                  <div className="stat-label">Analysis</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">DEEP</div>
                  <div className="stat-label">Insights</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">FLEXIBLE</div>
                  <div className="stat-label">Deployment</div>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 17L12 22L22 17M2 12L12 17L22 12M12 2L22 7L12 12L2 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="stat-content">
                  <div className="stat-value">INTEGRATE</div>
                  <div className="stat-label">iFRAMEs</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-pattern"></div>
      </section>

      {/* Key Features Section */}
     <KeyFeatures />

      {/* How It Works Section */}
      <HowItWorks 
        title="Graph Intelligence Platform"
        subtitle="How Our Technology Works"
        description="Our cutting-edge platform transforms raw data into actionable intelligence through advanced graph analysis and network relationships:"
        features={[
          "Analyzes complex entity relationships and network patterns in real-time",
          "Identifies hidden risk factors through multi-dimensional data correlation",
          "Provides predictive insights based on historical relationship patterns",
          "Delivers instant, actionable intelligence through intuitive front end solution"
        ]}
        additionalText="By leveraging the power of graph technology, we uncover insights that traditional linear analysis methods simply cannot detect, enabling smarter decisions across your entire organization."
        imageAlt="Graph Intelligence Platform Visualization"
        variant="general"
      />


      {/* Implementation Process Section */}
      <section className="implementation-section">
        <div className="container">
          <div className="section-header">
            <div className="section-label">Getting Started</div>
            <h2 className="section-title">Flexible Implementation Options</h2>
            <p className="section-subtitle">Deploy our enterprise-ready solution in the way that works best for your business</p>
          </div>

          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Complete Front-End Solution</h3>
                <p>Get up and running instantly with our turnkey, cloud-based platform featuring an intuitive dashboard and visualizations—zero configuration required.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>API-First Integration</h3>
                <p>Leverage our enterprise-grade API to seamlessly incorporate our graph intelligence capabilities into your existing tech stack with full customization flexibility.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Embedded iFrame Components</h3>
                <p>Integrate our powerful visualization modules directly into your application through secure, responsive iFrames for a unified user experience.</p>
              </div>
            </div>
          </div>
        </div>
      </section> 
    </div>
  );
};

export default Solution;